import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class EnergyChartScrollArrow extends Component {
  onClick = () => {
    if (this.props.isEnabled) {
      this.props.onClick();
    }
  };

  render() {
    const classes = classNames({
      "cb-c-energy-chart__arrows__arrow": true,
      "cb-c-energy-chart__arrows__arrow--disabled": !this.props.isEnabled
    });

    return (
      <div
        className={classes}
        onClick={this.onClick}
        enabled={this.props.isEnabled.toString()}
      >
        <div className="cb-c-energy-chart__arrows__arrow__icon-container">
          <div className="cb-c-energy-chart__arrows__arrow__icon-container__icon">
            {this.props.icon}
          </div>
        </div>
      </div>
    );
  }
}

EnergyChartScrollArrow.propTypes = {
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func,
  isEnabled: PropTypes.bool
};

EnergyChartScrollArrow.defaultProps = {
  isEnabled: true
};

export default EnergyChartScrollArrow;
